import {
  SIGN_UP_ACTION,
  IS_COMPANY_NAME_EXIST_ACTION,
  EMAIL_EXIST,
  IS_COOPRATIVE_EMAIL,
} from "./constants";

export function signUpAction(payload, onSuccess) {
  return {
    type: SIGN_UP_ACTION,
    payload,
    onSuccess,
  };
}

export function isCompanyNameExistAction(payload, onChangeCompanySuccess) {
  return {
    type: IS_COMPANY_NAME_EXIST_ACTION,
    payload,
    onChangeCompanySuccess,
  };
}

export function isEmailExistAction(payload, onChangeEmailSuccess) {
  return {
    type: EMAIL_EXIST,
    payload,
    onChangeEmailSuccess,
  };
}

export function isCooperativeEmailAction(payload, onChangeSuccess) {
  return {
    type: IS_COOPRATIVE_EMAIL,
    payload,
    onChangeSuccess,
  };
}